import { useCallback, useEffect, useMemo, useState } from 'react';
import BoardDocsApi from 'libs/api/boardDocs';
import { useTableChangeFilterHook } from 'hooks/useTableChangeFilterHook';
import { useFilter } from 'hooks/useFilter';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useTranslationUi } from '../../../../../hooks/useTranslationUi';
import BoardDocLogsAdapter from './boardDoc-logs.adapter';
import { useApi } from 'hooks/useApi';

const defaultState = {
  logs: [],
  boarddoc: {},
  pagination: {
    current: 1,
    pageSize: 10,
    position: ['bottomCenter'],
    hideOnSinglePage: true,
    showSizeChanger: false,
  },
  sorting: {
    field: '',
    order: '',
  },
};

const api = new BoardDocsApi();

const getInitialState = () => defaultState;

export const useBoardDocsLogs = () => {
  const {
    handleLogsDownloadExcel,
  } = useApi({
    resourceKey: 'boarddocslogs',
    singleResourceKey: 'boarddocslog',
    api,
    adapter: BoardDocLogsAdapter,
  });
  const { t } = useTranslation();
  const { id } = useParams();
  const onChangeTable = useTableChangeFilterHook();
  const { getBooleanText } = useTranslationUi();
  const { handleChangeFilters, handleCloseFilter, searchParams } = useFilter();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(getInitialState());

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        per: data.pagination.pageSize,
        page: data.pagination.current,
        ...Object.fromEntries([...searchParams]),
      };
      if (data.sorting.order) {
        params.sortable_column = data.sorting.field;
        params.direction = data.sorting.order;
      }
      const {
        data: { boarddoc, logs, pagination = {} },
      } = await api.get(`${id}/logs`, { params });
      setData((s) => ({
        ...s,
        logs: [...BoardDocLogsAdapter(logs || [])],
        boarddoc: boarddoc || {},
        pagination: {
          ...defaultState.pagination,
          ...pagination,
          total: pagination?.total_count,
        },
      }));
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, searchParams, data.pagination.current, data.sorting.order]);

  const onChangeTableFilter = useCallback(
    (paginate, sort, filter) => {
      onChangeTable(setData, paginate, sort, filter);
    },
    [onChangeTable],
  );

  const filters = useMemo(
    () => [
      {
        title: t('Insegna'),
        type: 'input',
        name: 'by_title',
      },
      {
        title: t('Letto Si/No'),
        type: 'select',
        name: 'is_readed',
        values: [
          { value: 1, title: t('Yes') },
          { value: 0, title: t('No') },
        ],
      },
    ],
    [t],
  );

  const columns = useMemo(() => {
    return [
      {
        title: t('Insegna'),
        dataIndex: 'companies.title',
        fixed: 'left',
        sorter: () => { },
      },
      {
        title: t('Letto?'),
        dataIndex: 'is_readed',
        sorter: () => { },
        render: (data) => getBooleanText(data),
      },
    ];
  }, [t, getBooleanText]);

  return {
    handleLogsDownloadExcel,
    data,
    columns,
    filters,
    loading,
    handleChangeFilters,
    handleCloseFilter,
    searchParams,
    onChangeTableFilter,
  };
};
